import {lang_tid} from "./i18n";

export function getLang(){
    const browserLang = navigator.language.split('-')[0];
    let lang = location.host.split(".")[0];
    //console.log(lang)
    //console.log(browserLang)
    if (lang in lang_tid) {return lang}
    if (browserLang in lang_tid) {return browserLang}
    return 'en'
}

export function isChinese(){
    return getLang() == 'zh';

}
